import { render, staticRenderFns } from "./dashboards.vue?vue&type=template&id=5383804c&scoped=true"
import script from "./dashboards.vue?vue&type=script&lang=ts"
export * from "./dashboards.vue?vue&type=script&lang=ts"
import style0 from "./dashboards.vue?vue&type=style&index=0&id=5383804c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5383804c",
  null
  
)

export default component.exports